import { Injectable } from '@angular/core';
import {
  type IAuthUserStatus,
  type IGeneratePasswordResetLinkRequest,
  type IGetAuthUserStatusRequest,
  type IPasswordResetLinkResponse,
  type ISetEmailVerifiedRequest,
  ManagementApiAction,
} from '@principle-theorem/principle-core/interfaces';
import { httpsCallable, snapshot } from '@principle-theorem/shared';

@Injectable({
  providedIn: 'root',
})
export class ManagementFunctionsService {
  async getAuthUserStatus(email: string): Promise<IAuthUserStatus> {
    return this._call<IGetAuthUserStatusRequest, IAuthUserStatus>({
      action: ManagementApiAction.GetAuthUserStatus,
      data: { email },
    });
  }

  async setEmailVerified(email: string): Promise<IAuthUserStatus> {
    return this._call<ISetEmailVerifiedRequest, IAuthUserStatus>({
      action: ManagementApiAction.SetEmailVerified,
      data: { email },
    });
  }

  async generatePasswordResetLink(
    email: string
  ): Promise<IPasswordResetLinkResponse> {
    return this._call<
      IGeneratePasswordResetLinkRequest,
      IPasswordResetLinkResponse
    >({
      action: ManagementApiAction.GeneratePasswordResetLink,
      data: { email },
    });
  }

  private async _call<T, R>(requestData: T): Promise<R> {
    return snapshot(httpsCallable<T, R>('http-management-api')(requestData));
  }
}
